<template>
  <div>

    <vx-card class="change-password-card">

     
      <div class="close-btn-div">

        <feather-icon
          icon="XIcon"
         
          style="width: 20px; height: 20px; color: #009696; cursor: pointer"
          @click="$router.go(-1)"
        />

      </div>

  
      <div style="margin-top:20px"></div>

   
      <div class="vx-row mb-4">

        <div class="vx-col sm:w-1/3 w-full topPad">
          <span class="inputStyles">
            Old Password
          </span>
        </div>

        <div class="vx-col sm:w-1/2 w-full">
          <vs-input
            type="password"
            class="w-full"
            v-model="form.oldPassword"
          />
        </div>

      </div>

   
      <div class="vx-row mb-4">

        <div class="vx-col sm:w-1/3 w-full topPad">
          <span class="inputStyles">
            New Password
          </span>
        </div>

        <div class="vx-col sm:w-1/2 w-full">
          <vs-input
            type="password"
            class="w-full"
            v-model="form.newPassword"
          />
        </div>

      </div>

      <div class="vx-row mb-4">

        <div class="vx-col sm:w-1/3 w-full topPad">
          <span class="inputStyles">
            Confirm Password
          </span>
        </div>

        <div class="vx-col sm:w-1/2 w-full">
          <vs-input
            type="password"
            class="w-full"
            v-model="form.confirmPassword"
          />
        </div>

      </div>

  
      <div class="button-container">

        <vs-button
          color="primary"
          type="filled"
          style="margin-right:10px"
          @click="changePassword"
        >
          Save
        </vs-button>

        <vs-button
          color="warning"
          type="border"
          @click="clearFields"
        >
          Clear
        </vs-button>

      </div>

    </vx-card>

  </div>
</template>

<script>
export default {

  data() {

    return {

      form: {

        oldPassword: "",

        newPassword: "",

        confirmPassword: "",

      },

    };

  },

  methods: {

   changePassword() {

  // EMPTY VALIDATION
  if (
    !this.form.oldPassword ||
    !this.form.newPassword ||
    !this.form.confirmPassword
  ) {

    this.$vs.notify({
      color: "danger",
      title: "Error",
      text: "All fields are required",
    });

    return;
  }

  // PASSWORD MATCH
  if (
    this.form.newPassword !==
    this.form.confirmPassword
  ) {

    this.$vs.notify({
      color: "danger",
      title: "Error",
      text: "Passwords do not match",
    });

    return;
  }

  let request = {

    oldPassword: this.form.oldPassword,

    newPassword: this.form.newPassword,

  };

  this.$http
    .post(
      "changePassword",
      JSON.stringify(request),
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
    .then((res) => {

      if(res.data.statusCode !== 200){

        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: res.data.message,
        });

        return;
      }

      this.$vs.notify({
        color: "success",
        title: "Success",
        text: "Password Changed Successfully",
      });

      this.clearFields();

    })
    .catch((err) => {

      this.$vs.notify({
        color: "danger",
        title: "Error",
        text: "Something went wrong",
      });

    });

},
    goBack() {

  this.$router.push("/Master");

},

    clearFields() {

      this.form = {

        oldPassword: "",

        newPassword: "",

        confirmPassword: "",

      };

    },

  },

};
</script>

<style scoped>

.change-password-card {
  min-height: 350px;
}

.close-btn-div {
  display: flex;
  justify-content: flex-end;
}

.button-container {
  display: flex;
  justify-content: center;
  margin-top: 35px;
}

.topPad {
  padding-top: 8px;
}

.inputStyles {
  font-weight: 500;
}

</style>